import { openModal } from "action/modal/openModal";
import SliderV2 from "component/design-system/carousel/SliderV2";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import { useTranslation } from "next-i18next";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getVideosWithThumbnails } from "util/videoThumbnailUtil";
import styles from "./manufacturer-video.module.scss";

const ManufacturerVideo = (props: any) => {
  const { manufacturerVideos = [] } = props;
  const { t } = useTranslation("product");
  const [videoThumbnails, setVideoThumbnails] = useState(manufacturerVideos);
  const dispatch = useDispatch();

  useEffect(() => {
    getVideosWithThumbnails(manufacturerVideos).then((_) => {
      setVideoThumbnails(_);
    });
  }, []);

  function handleOpenVideoModal(video: any, title: string) {
    dispatch(openModal("homepageVideoModal", {
      video,
      title,
    }));
  }

  return (
    <div className="m-t-20">
      <PAText
        component="h2"
        className="product_common_title"
        inlineBlock
        bold
      >
        {t("Videos for this product")}
      </PAText>

      <SliderV2
        ulClassName={styles.manufacturer_ul}
        className={styles.manufacturer_slider}
      >
        {videoThumbnails.map((video) => (
          <div key={video.title} className={styles.manufacturer_item}>
            <div className={styles.manufacturer_thumbnail}>
              <PAImage
                src={video.thumbnailUrl}
                alt={video.title}
                width={300}
                height={300}
                className={styles.manufacturer_image}
              />

              <i className={`fa fa-play ${styles.play_button}`} onClick={() => handleOpenVideoModal(video, video.title)}> </i>
            </div>
            <div className={styles.manufacturer_title}>
              <PAText bold color="black">
                {video.title}
              </PAText>
            </div>

            {/* <PAText component="p">{video.videoDescription}</PAText> */}
          </div>
        ))}
      </SliderV2>

      <HorizontalSeparator className="m-b-20 m-t-30" />
    </div>
  );
};

export default ManufacturerVideo;
